interface AnimatedFlagsProps {
	size?: "sm" | "md" | "lg";
	ariaLabel?: string;
}

export function AnimatedFlags({ size = "md", ariaLabel = "Germany and Switzerland" }: AnimatedFlagsProps) {
	const w = size === "sm" ? 20 : size === "lg" ? 32 : 24;
	const h = Math.round((w * 3) / 5);

	return (
		<span className="inline-flex items-center gap-1.5 align-middle" aria-label={ariaLabel}>
			<span
				className="inline-block overflow-hidden rounded-[2px] border border-border shadow-sm"
				style={{
					width: w,
					height: h,
					animation: "motion-flagWave 2.6s ease-in-out infinite",
					transformOrigin: "left center",
				}}
			>
				<svg viewBox="0 0 5 3" className="block h-full w-full" preserveAspectRatio="none" aria-hidden>
					<rect width="5" height="1" y="0" className="fill-foreground" />
					<rect width="5" height="1" y="1" className="fill-destructive" />
					<rect width="5" height="1" y="2" className="fill-[#FFCC00]" />
				</svg>
			</span>
			<span
				className="inline-block overflow-hidden rounded-[2px] border border-border shadow-sm"
				style={{
					width: h,
					height: h,
					animation: "motion-flagWave 2.6s ease-in-out infinite",
					animationDelay: "0.4s",
					transformOrigin: "left center",
				}}
			>
				<svg viewBox="0 0 32 32" className="block h-full w-full" preserveAspectRatio="none" aria-hidden>
					<rect width="32" height="32" className="fill-destructive" />
					<rect x="13" y="6" width="6" height="20" className="fill-background" />
					<rect x="6" y="13" width="20" height="6" className="fill-background" />
				</svg>
			</span>
		</span>
	);
}
